export default __webpack_public_path__ + "static/media/go-to-teacher.91af99e4.svg";